import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../css/contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((currentData) => ({
      ...currentData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
  event.preventDefault();

  const subject = `Portfolio enquiry from ${formData.name}`;
  const body = [
    `Name: ${formData.name}`,
    `Email: ${formData.email}`,
    "",
    "Message:",
    formData.message,
  ].join("\n");

  setFormData({
    name: "",
    email: "",
    message: "",
  });

  window.open(
    `mailto:bindus170@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  );

  
};

  return (
    <section
      className="w-full min-h-screen scroll-mt-15 px-5 py-24 md:px-16 lg:px-24"
      id="contact"
    >
      <div className="mx-auto max-w-6xl">
        <p className="text-center font-mono text-lg uppercase tracking-[0.35em] text-zinc-500">
          Contact
        </p>
        <h2 className="mt-4 text-center font-mono text-3xl font-semibold text-white md:text-4xl">
          Let&apos;s Build Something Meaningful
        </h2>
        <p className="mx-auto mt-4 max-w-3xl text-center text-base leading-7 text-zinc-300 md:text-lg">
          If you have a project, freelance opportunity, or a frontend role in
          mind, I&apos;d love to connect and hear more about it.
        </p>

        <div className="mt-12 grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <div data-aos="fade-right" className="space-y-5">
            <div className="contact-info-card">
              <div className="inline-flex rounded-full border border-white/10 bg-white/5 px-4 py-2 font-mono text-sm text-zinc-200 shadow-sm">
                Open to work | Freelance | Collaboration
              </div>

              <h3 className="mt-6 font-mono text-3xl font-semibold leading-tight text-white">
                Share your idea, role, or project and let&apos;s start the
                conversation.
              </h3>

              <p className="mt-5 leading-8 text-zinc-300">
                I enjoy building user-friendly interfaces and working on
                products that need thoughtful frontend structure, clean design,
                and responsive execution.
              </p>

              <div className="mt-8 space-y-4">
                <div className="contact-highlight">
                  <p className="contact-highlight-label">Best For</p>
                  <p className="contact-highlight-text">
                    Frontend projects, portfolio sites, and responsive UI work
                  </p>
                </div>
                <div className="contact-highlight">
                  <p className="contact-highlight-label">Working Style</p>
                  <p className="contact-highlight-text">
                    Clear communication, practical problem solving, and steady
                    delivery
                  </p>
                </div>
                <div className="contact-highlight">
                  <p className="contact-highlight-label">Current Focus</p>
                  <p className="contact-highlight-text">
                    React applications, reusable components, and polished user
                    experiences
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div data-aos="fade-left">
            <form
              onSubmit={handleSubmit}
              className="contact-form mx-auto grid gap-5 rounded-[2rem] p-8 md:p-10"
            >
              <div>
                <p className="font-mono text-sm uppercase tracking-[0.25em] text-zinc-500">
                  Send a message
                </p>
                <h3 className="mt-2 font-mono text-2xl font-semibold text-white">
                  I&apos;ll be happy to hear from you
                </h3>
              </div>

              <input
                className="w-full form"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
              />
              <input
                className="form"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
              />
              <textarea
                className="form min-h-[160px]"
                type="text"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write your message here..."
                required
              ></textarea>
              <button className="hero-submit-btn w-fit rounded-lg px-6 py-3 text-lg font-semibold">
                Send Message
              </button>
            </form>
          </div>
        </div>

        <p className="mt-16 border-t border-white/10 pt-6 text-center text-zinc-400">
          © 2024. Crafted with care. Please handle with respect.
        </p>
      </div>
    </section>
  );
};

export default Contact;
